import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { withRouter } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import { mapStateToProps, mapDispatchToProps } from '../../utils';
import { Theme } from '../../config/theme';

import ContentContainer from '../../components/ContentContainer';
import DogCard from '../../components/DogCard';

const PLUS_ASSET = require('./plus.svg');

class ShareHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.redirect = this.redirectToFind.bind(this);
  }

  componentWillMount() {
    // Redirect the user to Membership if they do not have an active subscription
    if (!this.props.user.active_subscription) {
      this.props.history.push('/settings/membership');
    }
  }

  getMatches() {
    const matches = this.props.user.matches;
    const relevantMatches = matches && matches.length ? matches.filter(match => (
      match.status === 'Declined' ||
      match.status === 'Ended'
    )) : false;

    return relevantMatches && relevantMatches.length ? relevantMatches : false;
  }

  redirectToFind() {
    this.props.history.push('/find');
  }

  renderMatches() {
    const matches = this.getMatches();

    return matches ? matches.map((match) => {
      const isBorrower = this.props.user.id === match.borrower.id;

      return (
        <DogCard
          member={!isBorrower}
          id={isBorrower ? match.dog.id : match.borrower.id}
          image={isBorrower ? match.dog.image_url : match.borrower.profile_photo}
          name={isBorrower ? match.dog.name : match.borrower.display_name}
          breed={isBorrower ? match.dog.breed : false}
          summary={isBorrower ? match.dog.about : match.borrower.bio}
          status={match.status.toLowerCase()}
        />
      );
    }) : false;
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <ContentContainer>
          <h1 className={css(styles.heading)}>My dog share history</h1>
          <div className={css(styles.cards)}>
            {
              this.renderMatches()
            }
            <div
              tabIndex={0}
              role="button"
              onClick={this.redirect}
              className={css(styles.more)}>
              <Isvg
                cacheGetRequests
                src={PLUS_ASSET}
                className={css(styles.more_icon)}
              />
              Find more Dogs
            </div>
          </div>
        </ContentContainer>
      </div>
    );
  }
}

ShareHistory.propTypes = {
  history: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  more_icon: {
    display: 'block',
    marginBottom: 21,

    ':not(.a) > svg > g': {
      transition: 'all 300ms',
    },
  },
  more: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 262,
    minWidth: 262,
    padding: '100px 18px',
    margin: '0 15px 23px',
    backgroundColor: '#f2f2f2',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e8e8e8',
    fontSize: 15,
    color: '#39b4d6',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    transition: 'all 300ms',
    cursor: 'pointer',

    ':hover': {
      color: Theme.white,
      backgroundColor: '#39b4d6',
    },

    ':hover > .isvg > svg > g': {
      fill: Theme.white,
    },

    [Theme.mobile_query]: {
      width: '100%',
    },

    '@media screen and (min-width: 625px) and (max-width: 768px)': {
      width: 262,
    },
  },
  actions: {
    margin: '0 -5px',

    '@media screen and (max-width: 1170px)': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    marginBottom: 30,
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 135,
  },
  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -15px -15px',

    [Theme.mobile_query]: {
      padding: '0 20px',
    },

    '@media screen and (max-width: 1170px)': {
      justifyContent: 'center',
    },
  },
  container: {
    paddingTop: 75,
    paddingBottom: 150,
  },
  heading: {
    marginBottom: 60,
    textAlign: 'center',
    fontSize: 45,
    lineHeight: 2.09,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  title: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center',
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareHistory));



// WEBPACK FOOTER //
// ./src/views/ShareHistory/index.js